import * as React from 'react';
import { useContext, useState } from 'react';
import { Grid } from '@material-ui/core';
import { AuthContext } from '../../_auth/AuthContext';
import { IUserState } from '../../_types/user';
import { IChangeEventHandler } from '../../_types/nav';
import { stupidDateFormat, fromStupidDateFormat } from '../../_util/Utility';
import DateFnsUtils from '@date-io/date-fns';
import { ISelectorDefault, search_param } from '../../_types/search';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';

interface Props {
    onChange: IChangeEventHandler<search_param>;
    searchParam: search_param;
    selector_cn: string;
    disabled?: boolean;
};

export const DateBetweenSelectorDefaults = 
    (selector_cn: string): ISelectorDefault => {
        let now = new Date();
        let yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 7);
        return {
            comparison: "between",
            values: [stupidDateFormat(yesterday), stupidDateFormat(now)]
        };
    };


const DateBetweenSelector: React.FC<Props> = (prop: Props) => {

    const userState: IUserState = useContext(AuthContext);


    const beginDate = () => {
        let toReturn: Date = new Date();
        
    
        if (prop.searchParam.values != null && prop.searchParam.values.length > 0) {
     
            let toParse = prop.searchParam.values[0];
    
            if (toParse.length > 0) {
          
                toReturn = fromStupidDateFormat(toParse);
            
            }
        }


        return toReturn;
    }

    const endDate = () => {
        let toReturn: Date = new Date();
        
        if (prop.searchParam.values != null && prop.searchParam.values.length > 1) {
            let toParse = prop.searchParam.values[1];
    
            if (toParse.length > 0) {
          
                toReturn = fromStupidDateFormat(toParse);
            }
        }


        return toReturn;
    }

    const handleBeginDateChange = (date: Date | null) => {
        let value = date as Date;
        

        let updated = stupidDateFormat(value);
        

        let p = { ...prop.searchParam };

        if (p.values == null || p.values.length == 0) {
            p.values = [updated];
        } else {
            p.values[0] = updated;
        }
        
        p.comparison = "between";
        prop.onChange(p);
      };

      const handleEnddateChange = (date: Date | null) => {
        let value = date as Date;
        
   
        let updated = stupidDateFormat(value);


        let p = { ...prop.searchParam };

        if (p.values == null || p.values.length == 0) {
            let now = new Date();
            p.values = [stupidDateFormat(now), updated];
        } else if (p.values.length == 1) {
            p.values.push(updated);
        } else {
            p.values[1] = updated;
        }
        
        p.comparison = "between";
        prop.onChange(p);
      };


return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <Grid container direction="row" justify="space-around">
        <Grid item>
        <KeyboardDatePicker disabled={prop.disabled}
          
          variant="dialog"
          allowKeyboardControl={false}
          format="yyyy-MM-dd"
          margin="normal"
          id="date-start"
          label="Start from"
          value={beginDate()}
          onChange={handleBeginDateChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
        </Grid>
        <Grid item>
        <KeyboardDatePicker disabled={prop.disabled}
          
          variant="dialog"
          allowKeyboardControl={false}
          format="yyyy-MM-dd"
          margin="normal"
          id="date-end"
          label="End at"
          value={endDate()}
          onChange={handleEnddateChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
        </Grid>
    </Grid>
    </MuiPickersUtilsProvider>
)
}

export default DateBetweenSelector;